import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, INK, Reveal, Title } from '../components/deck/Type';
const hero = [{
  value: '~$200K',
  label: 'Annual recurring revenue',
  tone: '#F4F7FC'
}, {
  value: '25,000+',
  label: 'Companies in the database',
  tone: INK.blue
}, {
  value: '20,000+',
  label: 'Startups assessed',
  tone: INK.violet
}, {
  value: '12',
  label: 'Customer & partner organisations',
  tone: INK.emerald
}];
const supporting = [{
  value: '$100K',
  label: 'Sony Innovation Fund engagement'
}, {
  value: '5',
  label: 'Venture funds signed'
}, {
  value: '7',
  label: 'Raiseboards live'
}, {
  value: '36',
  label: 'Companies on Raiseboards'
}, {
  value: '~90%',
  label: 'Diligence time saved'
}, {
  value: '2',
  label: 'Provisional patents filed'
}];
const ladder = [{
  stage: 'Pilot contract',
  value: '$100K',
  detail: 'DiligenceGPT™ for a defined mandate',
  tone: INK.blue
}, {
  stage: 'Expanded engagement',
  value: '$250K',
  detail: 'DiligenceGPT™ + consulting + integrations',
  tone: INK.violet
}, {
  stage: 'Enterprise infrastructure',
  value: 'Custom',
  detail: 'Bespoke deployment, full integration, consulting',
  tone: INK.emerald
}];
export function TractionSlide() {
  return <Slide index={11} data-id="element-550" data-mp="2owu84coz8u4c">
      <div className="flex items-start justify-between gap-[3cqw]" data-id="element-551" data-mp="2oy5dggy2m9xk">
        <div className="max-w-[62%]" data-id="element-552" data-mp="2k4kdijcx35vq">
          <Eyebrow data-id="element-553" data-mp="2k3j1oco2ufcy">Traction</Eyebrow>
          <Title className="mt-[2.2cqh]" data-id="element-554" data-mp="2xvz9dqrxb1k7">The evidence that this is working.</Title>
        </div>
        <Caption className="max-w-[30%] text-right" data-id="element-555" data-mp="2tvoutpq2f2tq">
          Revenue, data scale and institutional adoption — all from the
          current platform.
        </Caption>
      </div>

      <div className="mt-[4cqh] grid grid-cols-4 gap-[2.4cqw]" data-id="element-556" data-mp="32w3fqnz4afwp">
        {hero.map((m, i) => <Reveal key={m.label} delay={0.06 * i} className="border-t border-white/15 pt-[2.2cqh]" data-id="element-557" data-mp="1dgnio6ygwkn6" data-mpi={i}>
            <p className="text-[clamp(30px,3.9cqw,84px)] leading-none" style={{
          fontFamily: 'var(--font-serif)',
          color: m.tone
        }} data-id="element-558" data-mp="18i2gw33khswm">
              {m.value}
            </p>
            <p className="mt-[1.4cqh] text-[clamp(8px,0.84cqw,17px)] uppercase tracking-[0.18em] text-[#7C8699]" data-id="element-559" data-mp="3din3g986mk1h">
              {m.label}
            </p>
          </Reveal>)}
      </div>

      <Reveal delay={0.3} className="mt-[4cqh] grid grid-cols-6" data-id="element-560" data-mp="3mjl5ilz28hhf">
        {supporting.map((m, i) => <div key={m.label} className={i === 0 ? 'pr-[1cqw]' : 'border-l border-white/10 pl-[1.2cqw] pr-[1cqw]'} data-id="element-561" data-mp="3rjg132ts5v8t" data-mpi={i}>
            <p className="text-[clamp(16px,1.8cqw,38px)] leading-none text-[#DCE3EE]" style={{
          fontFamily: 'var(--font-serif)'
        }} data-id="element-562" data-mp="asfqmvji819">
              {m.value}
            </p>
            <p className="mt-[1cqh] text-[clamp(7.5px,0.78cqw,16px)] leading-tight text-[#7C8699]" data-id="element-563" data-mp="96rkw1rfwdbw">
              {m.label}
            </p>
          </div>)}
      </Reveal>

      <div className="mt-auto" data-id="element-564" data-mp="j3e4yobxz0cv">
        <span className="text-[clamp(8px,0.82cqw,17px)] uppercase tracking-[0.22em] text-[#3B8CFF]" data-id="element-565" data-mp="t71m940m8y9m">
          Enterprise client business model
        </span>
        <div className="mt-[1.8cqh] flex items-stretch gap-[1cqw]" data-id="element-566" data-mp="o6dlhqml5327">
          {ladder.map((step, i) => <React.Fragment key={step.stage} data-id="element-567" data-mp="j95ac9zutzag" data-mpi={i}>
              {i > 0 && <div className="flex items-center px-[0.4cqw] text-[clamp(12px,1.3cqw,28px)] text-white/30" data-id="element-568" data-mp="f8lfjd2r77rh">→</div>}
              <Reveal delay={0.36 + i * 0.08} className="flex flex-1 items-baseline gap-[1.2cqw] border border-white/10 bg-white/[0.03] px-[1.3cqw] py-[1.8cqh]" data-id="element-569" data-mp="1bznc97ouduma">
                <p className="text-[clamp(16px,1.9cqw,40px)] leading-none text-[#F4F7FC]" style={{
              fontFamily: 'var(--font-serif)'
            }} data-id="element-570" data-mp="125d7eqipr3uo">
                  {step.value}
                </p>
                <div data-id="element-571" data-mp="1px25kni7umjj">
                  <span className="text-[clamp(7.5px,0.78cqw,16px)] uppercase tracking-[0.2em]" style={{
                color: step.tone
              }} data-id="element-572" data-mp="1pwiplcc4m885">
                    {step.stage}
                  </span>
                  <Caption className="mt-[0.6cqh]" data-id="element-573" data-mp="11em6xmbpsxgg">{step.detail}</Caption>
                </div>
              </Reveal>
            </React.Fragment>)}
        </div>
      </div>
    </Slide>;
}